import { createContext } from 'react';
import { PageSetting, PageFilter } from '../model/page';

export const defaultPageFilter: PageFilter =  {
    level: 'Store',
    regions: [],
    stores: []
}

export const defaultPageSetting: PageSetting =  {
    filter: defaultPageFilter,
    activeFilter: defaultPageFilter,
    views: [],
    activeViewIndex: -1,
    isLoaded: false
}

export const PageContext = createContext<PageSetting>( defaultPageSetting );